import type { ZudokuConfig } from "zudoku";

export const site: ZudokuConfig["site"] = {
	// banner: {
	//   message: "This is a beta version of the Beam Developer Portal.",
	//   color: "note", // "note" | "tip" | "info" | "caution" | "danger" or custom
	//   dismissible: true
	// },
	title: "Beam Developer Portal",
	logo: {
		src: { light: "/logo-light.png", dark: "/logo-dark.png" },
		alt: "Beam Connectivity",
		width: "110px",
	},
	footer: {
		copyright: `© ${new Date().getFullYear()} Beam Connectivity Ltd. All rights reserved.`,
		columns: [
			{
				title: "Product",
				position: "center",
				links: [
					{
						label: "Connectivity as a Service",
						href: "https://beamconnectivity.com/caas-platform/",
					},
					{ label: "Contact", href: "https://beamconnectivity.com/contact/" },
					{
						label: "Support",
						href: "https://support.beamconnectivity.com/support/login",
					},
				],
			},
			{
				title: "Company",
				links: [
					{ label: "About", href: "https://beamconnectivity.com/our-story/" },
					{
						label: "News",
						href: "https://beamconnectivity.com/news-and-insights/",
					},
					{ label: "Join Us", href: "https://beamconnectivity.com/careers/" },
				],
			},
		],
	},
};
